/**
 * Hides the volume discount promotion for visitors from countries where the
 * Dealeasy discounts don't apply (theme setting "Countries without volume
 * discounts"), using Shopify's own location detection.
 *
 * The Dealeasy discounts are restricted to specific markets in Shopify, but a
 * visitor on a single-domain store may still browse in the default market
 * context. This script asks Shopify which country it detects for the visitor
 * and, if that country is excluded, adds the "dealeasy-hidden" class to <html>
 * (CSS hides the badge and the Dealeasy widgets) and remembers the outcome for
 * the session. layout/theme.liquid applies the remembered outcome inline on
 * later pages, before the Dealeasy script runs, so its widgets are then not
 * rendered at all.
 */
(function () {
  var excluded = window.dealeasyHiddenCountries || [];
  if (!excluded.length) return;

  var storageKey = 'dealeasy-hidden-country';
  try {
    // Already decided earlier in this session (theme.liquid applied it inline).
    if (sessionStorage.getItem(storageKey) !== null) return;
  } catch (error) {
    // Storage unavailable (private mode etc.): detect on every page instead.
  }

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  fetch(root + 'browsing_context_suggestions.json?country%5Benabled%5D=true', { credentials: 'same-origin' })
    .then(function (response) {
      return response.ok ? response.json() : null;
    })
    .then(function (data) {
      var detected = data && data.detected_values && data.detected_values.country && data.detected_values.country.handle;
      var hidden = !!detected && excluded.indexOf(String(detected).toUpperCase()) !== -1;

      try {
        sessionStorage.setItem(storageKey, hidden ? 'true' : 'false');
      } catch (error) {}

      if (hidden) {
        document.documentElement.classList.add('dealeasy-hidden');
        window.dealeasyIsB2BCustomer = true;
      }
    })
    .catch(function () {});
})();
